
















































































import {
  Component,
  Vue,
  namespace,
  Watch,
  mixins,
} from 'nuxt-property-decorator'
import { Route } from 'vue-router'
import {
  mdiChartBoxOutline,
  mdiChartBoxPlusOutline,
  mdiClose,
  mdiHeart,
  mdiHeartOutline,
  mdiInformationOutline,
  mdiGiftOutline,
  mdiCheckCircleOutline,
  mdiContentCopy,
} from '@mdi/js'
import LazyHydrate from 'vue-lazy-hydration'
import { Clipboard } from '@capacitor/clipboard'
import { NotificationOptions } from 'vue-notification'
import { NuxtAppOptions } from '@nuxt/types'
import { PRODUCTS_API } from '~/assets/config/api-path'
import { IStyle } from '~/assets/interfaces/classes'
import {
  IBreadcrumbsItem,
  ISeoFiltersItem,
} from '~/assets/interfaces/navigation'
import { IMeta } from '~/assets/interfaces/meta'
import {
  InterfaceProductsBlock,
  IParamBlock,
  IParamItem,
  IProduct,
  IProductAdditionalService,
  IProductAspectsItem,
  IProductAspectsVariant,
  IProductDocumentsItem,
  IProductPromocode,
  IProductSizeChart,
  IProductToCart,
  IProductToCompare,
  IProductToFavourites,
  IProductBrand,
  IProductsRaw,
} from '~/assets/interfaces/products'
import { IFavouriteItem } from '~/assets/interfaces/favourites'
import { ICompareItem } from '~/assets/interfaces/compare'
import { IImageVariants } from '~/assets/interfaces/images'
import { IReview } from '~/assets/interfaces/reviews'
import '~/assets/scss/v-tooltip.scss'
import { ICollectionProductsBlock } from '~/assets/interfaces/collection'
import { filterUrl } from '~/assets/filters/url'
import { IBonus } from '~/assets/interfaces/bonus'
import MixinGeneral from '~/assets/mixins/general'
import { IPriceItem } from '~/assets/interfaces/price'
import { COMPARE_PATH } from '~/assets/config/path'
import { analyticsReachGoal } from '~/assets/functions/analytics'
import ComponentNavigationBreadcrumbs from '~/components/navigation/breadcrumbs.vue'
import ComponentPageContent from '~/components/pages/content.vue'

interface IProductDescriptionRaw {
  title: string
  text: string
}

interface IProductParamsRaw {
  title: string
  full?: IParamBlock[]
  short?: IParamItem[]
}

interface IProductDocumentsRaw {
  title: string
  items: IProductDocumentsItem[]
}

interface ISectionBlock {
  title: string
  code: string
}

interface ISeoLinksRaw {
  title: string
  items: ISeoFiltersItem[]
}

const pageStore = namespace('page')
const compareStore = namespace('compare')
const favouritesStore = namespace('favourites')
const siteStore = namespace('site')
const catalogStore = namespace('catalog')

@Component({
  layout: (ctx) => (ctx.$device.isMobileOrTablet ? 'mobile' : 'default'),
  components: {
    LazyHydrate,
    ComponentPageContent,
    ComponentNavigationBreadcrumbs,
    ComponentProductPageDesktop: () =>
      import('~/components/pages/products/product-page-desktop.vue'),
    ComponentProductPageMobile: () =>
      import('~/components/pages/products/product-page-mobile.vue'),
    ComponentProductPageSections: () =>
      import('~/components/pages/products/product-page-sections.vue'),
    ComponentProductPageOverlays: () =>
      import('~/components/pages/products/product-page-overlays.vue'),
  },
  filters: {
    filterUrl,
  },
})
export default class pageCatalogSection extends mixins(MixinGeneral) {
  private async asyncData({
    $axios,
    route,
    error,
  }: {
    $axios: NuxtAppOptions
    route: NuxtAppOptions
    error: any
  }) {
    try {
      const response = await $axios.$get(PRODUCTS_API + '/' + route.params._id)
      return response
    } catch (err: any) {
      const statusCode =
        err && err.response && err.response.status
          ? (err.response.status as number)
          : 400
      switch (statusCode) {
        case 400:
          error({ statusCode: 400, message: 'Bad Request' })
          break
        case 403:
          error({ statusCode: 403, message: 'Forbidden' })
          break
        case 404:
          error({ statusCode: 404, message: 'Post not found' })
          break
        case 500:
          error({ statusCode: 500, message: 'Internal Server Error' })
          break
        case 502:
          error({ statusCode: 502, message: 'Bad Gateway' })
          break
        default:
          error({ statusCode: 400, message: 'Bad Request' })
          break
      }
    }
  }

  @siteStore.Getter('getLayoutHeaderMobileNumber')
  readonly layoutHeaderMobileNumber!: 2 | 4

  @favouritesStore.Action('toFavourites') private toFavourites!: (
    product: IProductToFavourites
  ) => Promise<void>

  @compareStore.Action('toCompare') private toCompareAction!: (
    product: IProductToCompare
  ) => Promise<void>

  @favouritesStore.State('items') private favouritesItems!: IFavouriteItem[]
  @compareStore.State('items') private compareItems!: ICompareItem[]

  @pageStore.Mutation('setBreadcrumbs') private setBreadcrumbs!: (
    breadcrumbs: IBreadcrumbsItem[]
  ) => void

  @pageStore.Mutation('setMeta') private setMeta!: (meta: IMeta) => void

  @siteStore.State('origin') private origin!: string
  @siteStore.Getter('getOptionsCurrencyCode')
  private getOptionsCurrencyCode!: string

  @siteStore.Getter('getOptionsProductInStockViewType')
  private productInStockViewType!: string

  @catalogStore.State('backFromProductName')
  readonly backFromProductName!: string | null

  @catalogStore.State('backFromCatalogName')
  readonly backFromCatalogName!: string | null

  @catalogStore.Mutation('setBackFromProductName')
  private setBackFromProductName!: (val: string | null) => void

  @catalogStore.Mutation('setBackFromCatalogName')
  private setBackFromCatalogName!: (val: string | null) => void

  @catalogStore.Mutation('setProducts')
  private catalogSetProduct!: (val: IProductsRaw | null) => void

  @siteStore.Getter('getLayoutHeaderNumber') readonly layoutHeaderNumber!: 5 | 7

  private fixedHeaderNumbers = [5, 7]

  @Watch('isPhotoPopup')
  private isPhotoPopupHandler(val: boolean) {
    if (process.client) {
      if (val) {
        window.addEventListener('keyup', this.onEscapeKeyUp)
      } else {
        window.removeEventListener('keyup', this.onEscapeKeyUp)
      }
    }
  }

  private meta: IMeta | null = null
  private breadcrumbs: IBreadcrumbsItem[] = []
  private id: number = 0
  private inStock: boolean = false
  private sizeChart: null | IProductSizeChart = null
  private isShowSizeChart = false
  private isShowBuyOneClick = false
  private isCanBuyOneClick = false
  private isShowReportArrivalProduct = false
  private unit: string | null = null
  private multiplicity = 1
  private collection: ICollectionProductsBlock | null = null
  private bonus: IBonus | null = null
  private documents: IProductDocumentsRaw | null = null
  private set: null | { items: IProduct[] } = null
  private ratio: string = '1 / 1'
  private isShowAvailabilityStores = false
  private availableQuantity: null | number = null
  private availableDate: null | string = null
  private canUploadPhoto = false
  private hasVideo = false
  private additionalServices: IProductAdditionalService[] = []
  private additionalServicesForBuy: IProductAdditionalService[] = []
  private promocodes: IProductPromocode[] = []
  private description: IProductDescriptionRaw | null = null
  private params: IProductParamsRaw | null = null
  private isShowSpecificationNote = false
  private seoLinks: ISeoLinksRaw | null = null
  private countryBuildName: string = ''
  private countryBuildImg: string = ''

  private get mobileViewProps() {
    return {
      labels: this.labels,
      reviews: this.reviews,
      id: this.id,
      isInCompare: this.isInCompare,
      isInFavourites: this.isInFavourites,
      icons: this.icons,
      toCompareText: this.toCompareText,
      imageToShare: this.getImageToShare(),
      titleToShare: this.meta ? this.meta.h1 : '',
      urlToShare: this.urlToShare,
      articleIsCopied: this.articleIsCopied,
      vendorCode: this.vendorCode,
      copyLinkIcon: this.copyLinkIcon,
      canUploadPhoto: this.canUploadPhoto,
      hasVideo: this.hasVideo,
      photosMobileArray: this.photosMobileArray,
      ratio: this.ratio,
      features: this.features,
      prices: this.prices,
      unit: this.unit,
      bonus: this.bonus,
      additionalServices: this.additionalServices,
      inStock: this.inStock,
      availableDate: this.availableDate,
      availableQuantity: this.availableQuantity,
      isShowAvailabilityStores: this.isShowAvailabilityStores,
      isCanBuyOneClick: this.isCanBuyOneClick,
      hasCredits: this.hasCredits,
      aspects: this.aspects,
      sizeChart: this.sizeChart,
      brand: this.brand,
      countryBuildName: this.countryBuildName,
      countryBuildImg: this.countryBuildImg,
      multiplicity: this.multiplicity,
      aspectsForBuy: this.aspectsForBuy,
      additionalServicesForBuy: this.additionalServicesForBuy,
      layoutHeaderMobileNumber: this.layoutHeaderMobileNumber,
      promocodes: this.promocodes,
      isNativePlatform: this.isNativePlatform,
    }
  }

  private get desktopViewProps() {
    const isFixedHeader =
      !!this.layoutHeaderNumber &&
      this.fixedHeaderNumbers.includes(this.layoutHeaderNumber)

    return {
      labels: this.labels,
      reviews: this.reviews,
      toFavouritesText: this.toFavouritesText,
      id: this.id,
      isInFavourites: this.isInFavourites,
      icons: this.icons,
      toCompareText: this.toCompareText,
      isInCompare: this.isInCompare,
      imageToShare: this.getImageToShare(),
      titleToShare: this.meta ? this.meta.h1 : '',
      urlToShare: this.urlToShare,
      articleIsCopied: this.articleIsCopied,
      vendorCode: this.vendorCode,
      copyLinkIcon: this.copyLinkIcon,
      layoutHeaderNumber: this.layoutHeaderNumber,
      isFixedHeader,
      photosArray: this.photosArray,
      ratio: this.ratio,
      canUploadPhoto: this.canUploadPhoto,
      hasVideo: this.hasVideo,
      features: this.features,
      aspects: this.aspects,
      unit: this.unit,
      sizeChart: this.sizeChart,
      paramsShort: this.params && this.params.short ? this.params.short : [],
      brand: this.brand,
      countryBuildName: this.countryBuildName,
      countryBuildImg: this.countryBuildImg,
      prices: this.prices,
      bonus: this.bonus,
      additionalServices: this.additionalServices,
      inStock: this.inStock,
      availableDate: this.availableDate,
      availableQuantity: this.availableQuantity,
      isShowAvailabilityStores: this.isShowAvailabilityStores,
      multiplicity: this.multiplicity,
      additionalServicesForBuy: this.additionalServicesForBuy,
      aspectsForBuy: this.aspectsForBuy,
      isCanBuyOneClick: this.isCanBuyOneClick,
      hasCredits: this.hasCredits,
      promocodes: this.promocodes,
    }
  }

  private created(): void {
    if (this.meta) {
      this.setMeta(this.meta)
    }
    if (this.breadcrumbs) {
      this.setBreadcrumbs(this.breadcrumbs)
    }
  }

  private onClickReportArrivalProduct() {
    this.isShowReportArrivalProduct = true
    analyticsReachGoal('goal_receipt_of_goods_begin')
  }

  private get isInFavourites() {
    return !!this.favouritesItems.find((item) => {
      return item.id === this.id
    })
  }

  private get isInCompare() {
    return !!this.compareItems.find((item) => {
      return item.id === this.id
    })
  }

  private get toFavouritesText() {
    return this.isInFavourites ? 'Удалить из избранного' : 'В избранное'
  }

  private get toCompareText() {
    return this.isInCompare ? 'Перейти в сравнение' : 'Сравнить'
  }

  private get urlToShare() {
    if (process.client) {
      return this.origin + this.$route.path
    } else {
      return ''
    }
  }

  private getImageToShare() {
    if (this.images.length === 0) {
      return ''
    }

    if (!Object.keys(this.images[0]).includes('small')) {
      return ''
    }

    const image = this.images[0].small
    if (typeof image === 'string') {
      return image
    } else {
      return Object.values(image)[0] as string
    }
  }

  private icons = {
    mdiHeartOutline,
    mdiHeart,
    mdiChartBoxPlusOutline,
    mdiChartBoxOutline,
    mdiClose,
    mdiInformationOutline,
    mdiGiftOutline,
    mdiCheckCircleOutline,
    mdiContentCopy,
  }

  private images: IImageVariants[] = []

  private get photosArray() {
    return this.images.map((image: IImageVariants) => {
      return {
        small: image.small,
        medium: image.medium,
        large: image.large,
        lazyLoad: image.lazyLoad,
        isUserPhoto: image.isUserPhoto,
        meta: image.meta,
      }
    })
  }

  private get photosMobileArray() {
    return this.images.map((image: IImageVariants) => {
      return {
        image: image.medium,
        lazyLoad: image.lazyLoad,
        isUserPhoto: image.isUserPhoto,
        meta: image.meta,
      }
    })
  }

  private articleIsCopied = false

  private get copyLinkIcon() {
    return this.articleIsCopied
      ? this.icons.mdiCheckCircleOutline
      : this.icons.mdiContentCopy
  }

  private async copyArticle() {
    if (!this.articleIsCopied) {
      if (this.isNativePlatform) {
        await Clipboard.write({ string: this.vendorCode })
      } else {
        await navigator.clipboard.writeText(this.vendorCode)
      }

      this.articleIsCopied = true

      Vue.notify({
        group: 'default',
        type: 'info',
        title: 'Скопировано',
        text: 'Артикул успешно скопирован',
        duration: 4300,
      } as NotificationOptions)

      setTimeout(() => {
        this.articleIsCopied = false
      }, 5000)
    }
  }

  private goToReviews() {
    ;(this.$refs.sections as any)?.goTo('reviews')
  }

  private isPhotoPopup = false
  private isLoading = false

  private photoStart = 0

  private photoPopupToggle(state: boolean = false, start: number = 0) {
    this.isPhotoPopup = state
    this.photoStart = start
  }

  private kit: InterfaceProductsBlock | null = null
  private products = {
    block1: [],
    block2: [],
  }

  private items = []
  private styleSpacer!: IStyle
  private aspects: IProductAspectsItem[] = []
  private aspectsForBuy: IProductToCart[] = []

  private changeLocation() {
    if (process.client) {
      window.location.reload()
    }
  }

  private JSONLDImage: string[] = []
  private JSONLDDescription: string = ''
  private vendorCode: string = ''
  private brand: IProductBrand | null = null
  private category: string = ''
  private name: string = ''
  private variant: string = ''
  private hasCredits = false

  private reviews: {
    title: string
    photosTitle: string
    rating: number
    amount: number
    photosAmount?: number
    canAdd?: boolean
    items?: IReview[]
  } | null = null

  private get structuredDataReviews() {
    if (!this.reviews) {
      return []
    }
    if (!this.reviews.items || this.reviews.items.length === 0) {
      return []
    }
    return this.reviews.items.map((item: IReview) => {
      return {
        '@type': 'Review',
        reviewRating: {
          '@type': 'Rating',
          ratingValue: item.rating,
          bestRating: '5',
        },
        author: {
          '@type': 'Person',
          name: item.name,
        },
        reviewBody: `${item.plus} ${item.minus} ${item.comment}`,
      }
    })
  }

  private get priceValidUntil() {
    const today = new Date()
    const plusMonth = new Date(today)
    plusMonth.setDate(plusMonth.getMonth() + 1)
    return plusMonth
  }

  private prices: IPriceItem[] = []

  private get structuredData() {
    let base = {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: this.meta ? this.meta.h1 : '',
      image: this.JSONLDImage,
      description: this.JSONLDDescription,
      sku: this.vendorCode,
      brand: {
        '@type': 'Brand',
        name: this.brand ? this.brand.title : '',
      },

      offers: {
        '@type': 'Offer',
        url: this.origin + this.$route.path,
        priceCurrency: this.getOptionsCurrencyCode,
        price: this.firstPrice.final,
        priceValidUntil: this.priceValidUntil.toISOString(),
        itemCondition: 'http://schema.org/NewCondition',
        availability: this.inStock
          ? 'https://schema.org/InStock'
          : 'https://schema.org/OutOfStock',
      },
    }
    if (this.reviews) {
      base = Object.assign(base, {
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: this.reviews.rating,
          reviewCount: this.reviews.amount,
        },
      })
      if (this.structuredDataReviews.length > 0) {
        base = Object.assign(base, {
          review: this.structuredDataReviews,
        })
      }
    }
    return base
  }

  private head() {
    return {
      script: [
        {
          json: this.structuredData,
          type: 'application/ld+json',
        },
      ],
    }
  }

  private mounted(): void {
    window.dataLayer = window.dataLayer || []
    if (window.dataLayer) {
      window.dataLayer.push({
        ecommerce: {
          currencyCode: 'RUB',
          detail: {
            products: [
              {
                id: this.id,
                name: this.name,
                price: this.firstPrice.final,
                brand: this.brand && this.brand.title ? this.brand.title : '',
                category: this.category || '',
                variant: this.variant || '',
              },
            ],
          },
        },
      })
    }
    if (this.$route.hash === '#reviews') {
      this.goToReviews()
    }
  }

  private sectionBlocks: ISectionBlock[] = []

  private onEscapeKeyUp(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.photoPopupToggle()
    }
  }

  private beforeDestroy() {
    window.removeEventListener('keyup', this.onEscapeKeyUp)
  }

  private beforeRouteLeave(to: Route, _: Route, next: any) {
    if (
      to.name !== 'catalog-_slug' ||
      (to.name === 'catalog-_slug' &&
        this.backFromCatalogName !== to.params._slug)
    ) {
      this.setBackFromProductName(null)
      this.setBackFromCatalogName(null)
      this.catalogSetProduct(null)
    }

    next()
  }

  private beforeRouteUpdate(_to: Route, _: Route, next: any) {
    this.setBackFromProductName(null)
    this.setBackFromCatalogName(null)
    this.catalogSetProduct(null)

    next()
  }

  private aspectsChangeQuantity(items: IProductAspectsVariant[]) {
    this.aspectsForBuy = items.map((item) => {
      return {
        id: item.id,
        quantity: item.quantityCurrent || 0,
      }
    })
  }

  private goToStores() {
    ;(this.$refs.sections as any)?.goTo('stores')
  }

  private get firstPrice():
    | IPriceItem
    | {
        value: number | null
        final: number | null
      } {
    return this.prices.length ? this.prices[0] : { value: null, final: null }
  }

  private hasScripts = false

  private async toCompare(product: IProductToCompare) {
    if (this.isInCompare) {
      await this.$router.push(filterUrl(COMPARE_PATH))
    } else {
      await this.toCompareAction(product)
    }
  }

  private changeAdditionalServices(event: IProductAdditionalService[]) {
    this.additionalServicesForBuy = event
  }

  private packaging: string[] = []
}
